import { trace } from 'owa-trace';
/**
 * Get the row instance key from the list view type
 * @param row the row data
 * @param listViewType the list view type
 */
export default function getRowKeyFromListViewType(row, listViewType) {
    switch (listViewType) {
        case 0 /* Conversation */:
            return row.InstanceKey;
        case 1 /* Message */:
            return row.InstanceKey;
        default:
            trace.warn('listViewType:' + listViewType + ' not supported');
            return null;
    }
}
//# sourceMappingURL=getRowKeyFromListViewType.js.map